import React from 'react'

import PeacefulnessIcon from 'components/icons/Peacefulness'
import RejuvinationIcon from 'components/icons/Rejuvenation'
import GroundednessIcon from 'components/icons/Groundedness'
import SlownessIcon from 'components/icons/Slowness'
import HumanConnectionIcon from 'components/icons/HumanConnection'
import JoyIcon from 'components/icons/Joy'
import UnpluggedIcon from 'components/icons/Unplugged'
import FreedomIcon from 'components/icons/Freedom'
import SelfDiscoveryIcon from 'components/icons/SelfDiscovery'
import ExcitementIcon from 'components/icons/Excitement'
import SpontaneityIcon from 'components/icons/Spontaniety'
import ChallengeIcon from 'components/icons/Challenge'
import type { FulfillingMomentName } from '../types'

const Icon = ({ momentName }: { momentName: FulfillingMomentName }) => {
  switch (momentName) {
    case 'peacefulness':
      return <PeacefulnessIcon />
    case 'rejuvenation':
      return <RejuvinationIcon />
    case 'groundedness':
      return <GroundednessIcon />
    case 'slowness':
      return <SlownessIcon />
    case 'human connection':
      return <HumanConnectionIcon />
    case 'joy':
      return <JoyIcon />
    case 'unplugged':
      return <UnpluggedIcon />
    case 'freedom':
      return <FreedomIcon />
    case 'self-discovery':
      return <SelfDiscoveryIcon />
    case 'excitement':
      return <ExcitementIcon />
    case 'spontaneity':
    case 'spontaniety':
      return <SpontaneityIcon />
    case 'challenge':
      return <ChallengeIcon />
    default:
      return <svg />
  }
}

export default Icon
